import classNames from 'classnames'
import React, { useState } from 'react'

import {
  HEADER_HEIGHT,
  SIDEBAR_CONTENT_WIDTH,
  SIDEBAR_SECTIONS_WIDTH,
} from '../../../../css/LayoutVariables'
import OnboardTooltip from '../../../components/onboard-tooltip'
import { useNavigationContext } from '../../../contexts/NavigationContext'
import { useEventFeedsContext } from '../context'

import './styles.scss'

const EventFeedsHeaderOnboardTooltips = ({ className, onFinish }) => {
  const { sidebarRetracted } = useNavigationContext()
  const { id } = useEventFeedsContext()

  const [step, setStep] = useState(id === 'discovery' ? 7 : 6)

  const numberOfSteps = id === 'discovery' ? 8 : 9
  const stepsOffset = id === 'discovery' ? -1 : 0

  return (
    <div className={classNames('event-feeds-header-onboard-tooltip__container', className)}>
      <div
        className="event-feeds-header-onboard-tooltip__backdrop"
        style={{
          left: SIDEBAR_SECTIONS_WIDTH + (!sidebarRetracted ? SIDEBAR_CONTENT_WIDTH : 0),
          width: '100%',
        }}
      />

      <If condition={step === 6 && id !== 'discovery'}>
        <OnboardTooltip
          contentClassName="event-feeds-header-onboard-tooltip__tooltip-filters"
          arrowDirection="top"
          step={6 + stepsOffset}
          numberOfSteps={numberOfSteps}
          right={305}
          top={HEADER_HEIGHT}
          title="Submit Delivery"
          description="Once you are done configuring your data feed, start creating a delivery request here and monitor the result anytime."
          onNextClick={() => {
            setStep(step + 1)
          }}
          onClose={() => onFinish(false)}
        />
      </If>

      <If condition={step === 7}>
        <OnboardTooltip
          contentClassName="event-feeds-header-onboard-tooltip__tooltip-filters"
          arrowDirection="top"
          step={7 + stepsOffset}
          numberOfSteps={numberOfSteps}
          right={155}
          top={HEADER_HEIGHT}
          title="Save Changes"
          description="Click here to save your changes to data explorer feed list."
          onNextClick={() => {
            setStep(step + 1)
          }}
          onClose={() => onFinish(false)}
        />
      </If>

      <If condition={step === 8}>
        <OnboardTooltip
          contentClassName="event-feeds-header-onboard-tooltip__tooltip-filters"
          arrowDirection="top"
          step={8 + stepsOffset}
          numberOfSteps={numberOfSteps}
          right={62}
          top={HEADER_HEIGHT}
          title="PDF Export & Snapshot"
          description="Showcase your data feed by exporting it in different versions here."
          onNextClick={() => {
            setStep(step + 1)
          }}
          onClose={() => onFinish(false)}
        />
      </If>

      <If condition={step === 9}>
        <OnboardTooltip
          contentClassName="event-feeds-header-onboard-tooltip__tooltip-filters"
          arrowDirection="top"
          step={9 + stepsOffset}
          numberOfSteps={numberOfSteps}
          right={0}
          top={HEADER_HEIGHT}
          title="Onboarding Tooltips"
          description="Click here to see the tour again."
          onNextClick={() => {
            setStep(step + 1)
            onFinish(true)
          }}
          onClose={() => onFinish(false)}
        />
      </If>
    </div>
  )
}

export default EventFeedsHeaderOnboardTooltips
